
fx.ns("shared.social", class AuthComponent extends fx.components.VBox
{  
    constructor(parameters)
    {
        super();

        this._social = parameters.social;
        this._icon = parameters.icon;
        this._iconWidth = parameters.width;
        this._iconHeight = parameters.height;
        this._service = parameters.service;
        this._text = parameters.text || fx.text("Si rien ne ne se passe après avoir cliqué sur le bouton ci-dessus, veuillez autoriser votre navigateur à afficher les popups.");
        this._logo = parameters.logo || null;
        this._numberClicks = 0;
        this.callback = this.callback.bind(this);
    }

    // ------------- RENDER -------------- //   
     
    create()
    {
        let authPanel = new fx.components.VBox();
        this.addChild(authPanel, {width: '100%', height: '100%'});

        let title= new fx.components.Text({text: this._social, className: "title"});

        if (this._logo)
        {
            let container = new fx.components.Box('container');
            let logoWrapper = new fx.components.HBox('logo-wrapper');
            let facebookLogo = new fx.components.Image(this._logo);
            logoWrapper.addChild(facebookLogo, {width:48, height:48});
            logoWrapper.addChild(title, {top: -5});
            container.addChild(logoWrapper, {left:'center', height:48})
            authPanel.addChild(container, {width: '100%', height:48});
        }
        else
        {
            authPanel.addChild(title, {width: '100%'});
        }

		let text1 = new fx.components.Text({text: fx.text("Cliquez sur le bouton ci-dessous pour vous connectez et autoriser notre application à importer vos photos."), className: "auth-text"});
		authPanel.addChild(text1, {width: '100%'});
		
		//this.authButton = new fx.components.Image({data: this._icon, className: 'auth-button'});
        this.authButton = new fx.components.Button({label : fx.text("Se connecter"), className: 'auth-button filled'});
		//authPanel.addChild(this.authButton, {width: this._iconWidth, height: this._iconHeight, left:'center'});
        authPanel.addChild(this.authButton, {left:'center'});

		this.popupWarning = new fx.components.Text({text: this._text, className: "auth-text"});		
        this.popupWarning.visibleAtStart = false;
        authPanel.addChild(this.popupWarning, {width: '100%'});	
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onAuth, this.authButton);
    }

	// ------------- HANDLERS -------------- //

    onAuth()
	{
        //this.loading(true);

        this._service.login(this.callback);
        
        this._numberClicks++;

        if (this._numberClicks >= 2)
            this.popupWarning.show();
    }

    

    callback(data)
    {
        //this.loading(false);

        if (data && data.error)
            this.trigger("error");
    }

});